export enum WebAppBrand {
    YouSee = "YouSee",
    Telmore = "Telmore"
}

export enum WebAppEnvironment {
    Development = "development",
    Production = "production"
}
